
import { Options, Vue } from "vue-class-component";
import { DashboardController } from "@/app/ui/controllers/DashboardController";
import MainDashboardV2 from "@/app/ui/views/dashboard/component/pos/main-dashboard-v2.vue";
import CodDashboard from "@/app/ui/views/dashboard/cod-dashboard/index.vue";
import PerformanceDashboard from "@/app/ui/views/dashboard/component/pos/performance-dashboard.vue";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { GTMCommonEvent } from "@/app/infrastructures/misc/gtm-event/common-event";
import { FlagsDashboardCod } from "@/feature-flags/dashboard/cod";
import { FlagsMedusa } from "@/feature-flags/flags-misc-medusa";
import TabHangingBkd from "./hanging/tab-hanging-bkd/index.vue";
import { FcsPermissionSttHanging } from "@/feature-flags/flags-permission-stt-hanging";
import TabRevenue from "./revenue/index.vue";
import TabCustomer from "./customer/index.vue";
import { TabsData } from "@/app/ui/components/tabs/module";
import { FcsPermissionRevenueDashboard } from "@/feature-flags/flags-permission-revenue-dashboard";
import { FcsPermissionDashboard } from "@/feature-flags/flags-dashboard";
import TabPosLeaderboard from "./leaderboard/index.vue";

@Options({
  components: {
    CodDashboard,
    MainDashboardV2,
    PerformanceDashboard,
    TabHangingBkd,
    TabRevenue,
    TabCustomer,
    TabPosLeaderboard
  }
})
export default class DashboardPos extends Vue {
  get dataProfile() {
    return AccountController.accountData;
  }
  get accountTypeDetail() {
    return this.dataProfile.account_type_detail;
  }
  get activeMenu() {
    return DashboardController.activeMenuTabs.main;
  }
  onChangeTabs(value: string) {
    const isRoutedTab = this.tabs.some(
      (tab) => tab.value === value && tab.isRoute
    );

    DashboardController.setActiveMenuTabs({ main: value });
    this.$router.push({
      path: "/dashboard",
      query: isRoutedTab ? { activeMenu: value } : undefined
    });

    const tab: any = {
      "main-dashboard": "pos_dashboard_utama",
      "performance-dashboard": "pos_dashboard_performa",
      "cod-dashboard": "dashboard_cod_clicked"
    };
    GTMCommonEvent(tab[value]);
  }

  mounted() {
    const activeMenu = FcsPermissionDashboard.permission_tab_leaderboard_enable.isEnabled()
      ? "leaderboard"
      : this.$route.query.activeMenu?.toString();
    const isValidTab = this.tabs.some((tab) => tab.value === activeMenu);
    const main = isValidTab ? activeMenu : "main-dashboard";

    DashboardController.setActiveMenuTabs({ main });
    this.$router.push({
      path: "/dashboard",
      query: isValidTab ? { activeMenu } : undefined
    });
  }

  get tabs(): TabsData[] {
    const tempTabs: TabsData[] = [
      new TabsData({
        value: "main-dashboard",
        title: this.$t("dashboard.tabUtama")
      })
    ];

    if (FcsPermissionDashboard.permission_tab_leaderboard_enable.isEnabled()) {
      tempTabs.unshift(
        new TabsData({
          value: "leaderboard",
          title: this.$t("dashboard.tabLeaderboard")
        })
      );
    }

    if (
      FlagsMedusa.config_pos_performance_dashboard.getValue() &&
      !this.dataProfile.isPosChildAccount
    ) {
      tempTabs.push(
        new TabsData({
          value: "performance-dashboard",
          title: this.$t("dashboard.tabPerforma")
        })
      );
    }
    if (
      this.accountTypeDetail.isCodDelivery &&
      !this.dataProfile.isPosChildAccount &&
      FlagsDashboardCod.permission_show_tab_cod_dashboard.isEnabled()
    ) {
      tempTabs.push(
        new TabsData({
          value: "cod-dashboard",
          title: this.$t("dashboard.tabCod")
        })
      );
    }

    if (FcsPermissionSttHanging.permission_hanging_bkd_pos_enable.isEnabled()) {
      tempTabs.push(
        new TabsData({
          value: "hanging-bkd",
          title: this.$t("dashboard.tabHangingBkd")
        })
      );
    }

    if (
      FcsPermissionRevenueDashboard.permission_revenue_dashboard_enable.isEnabled()
    ) {
      tempTabs.push(
        new TabsData({
          value: "revenue",
          title: this.$t("dashboard.tabRevenue"),
          isRoute: true
        })
      );
    }

    if (
      FcsPermissionRevenueDashboard.permission_customer_dashboard_enable.isEnabled()
    ) {
      tempTabs.push(
        new TabsData({
          value: "customer",
          title: this.$t("dashboard.tabCustomer"),
          isRoute: true
        })
      );
    }

    return tempTabs;
  }
}
